import { Component, Input } from '@angular/core';
import {
  CadastroContratoDto,
  MaritalStatus,
  MeioPagamento,
  OwnerDto,
  ProjetoTipo,
  PropertyDto,
  PropertyUsage,
  ReurbModalidade
} from '@usucampeao/lib-reurb-simplificado';
import { NumeroExtensoTipo } from '@usucampeao/utils';

@Component({
  selector: 'usucampeao-reurb-averbacao-v3',
  templateUrl: './reurb-averbacao-v3.component.html',
  styleUrls: ['./reurb-averbacao-v3.component.scss']
})
export class ReurbAverbacaoV3Component {
  @Input() cadastro!: CadastroContratoDto;
  @Input() proprietario!: Partial<OwnerDto>;
  @Input() conjuge!: Partial<OwnerDto>;
  @Input() imovel!: Partial<PropertyDto>;
  @Input() isPrint: boolean;

  public get imovelTipo(): typeof PropertyUsage {
    return PropertyUsage;
  }

  public get meioPagamento(): typeof MeioPagamento {
    return MeioPagamento;
  }

  public get numeroExtensoTipo(): typeof NumeroExtensoTipo {
    return NumeroExtensoTipo;
  }

  public get reurbModalidade(): typeof ReurbModalidade {
    return ReurbModalidade;
  }

  public get estadoCivil(): typeof MaritalStatus {
    return MaritalStatus;
  }

  public get projetoTipo(): typeof ProjetoTipo {
    return ProjetoTipo;
  }

  public get pagamentoAVista(): boolean {
    return !this.cadastro?.totalParcelas || this.cadastro.totalParcelas === 0;
  }

  public get possuiAverbacao(): boolean {
    return this.cadastro?.averbacao;
  }

  public get contratoSemPagamento(): boolean {
    return this.cadastro?.semPagamento;
  }

  public get tipoContrato(): string {
    if (this.cadastro.averbacao) {
      return 'CONTRATO DE ADESÃO PARA A PRESTAÇÃO DE SERVIÇOS DE REGULARIZAÇÃO FUNDIÁRIA E AVERBAÇÃO DE DECLARAÇÃO DE EXISTÊNCIA DE EDIFICAÇÃO';
    }

    return 'CONTRATO DE ADESÃO PARA A PRESTAÇÃO DE SERVIÇOS DE REGULARIZAÇÃO FUNDIÁRIA';
  }

  public get isPagamentoAVista(): boolean {
    return this.cadastro.pagamentos.length === 1;
  }
}
